import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
// import './polyfills'
// import 'jquery/src/jquery'
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import './assets/css/fonts.scss';

import * as serviceWorker from './serviceWorker';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { googleTagManagerId } from './config/clientConfig'

const tagManagerArgs = { gtmId: googleTagManagerId }
const App = lazy(() => import('./App'));
const rootElement = document.getElementById('root');

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
    <Suspense fallback={<div />}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Suspense>,
    rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();